import React, { useEffect } from 'react'
import { Wrapper } from '@googlemaps/react-wrapper'
import MapComponent from './components/MapComponent'
import useLanguage from './hooks/useLanguage'
import { useTranslation } from 'react-i18next'

import './fonts/Quickpen.otf'
import './fonts/QuickpenBold.otf'

const center = window.innerWidth > 1023 ? { lat: -25, lng: 5.447427 } : { lat: -30, lng: -45 }
const zoom = 2.5

const App: React.FC = () => {
  const { t } = useTranslation()
  const language = useLanguage()

  useEffect(() => {
    document.title = t('title')
  }, [t])

  return (
    <Wrapper apiKey='AIzaSyA7ENMZfyuov5-Q4jmeqQUwXjIF0TN6Ipk' language={language.substring(0, 2)}>
      <MapComponent center={center} zoom={zoom} />
    </Wrapper>
  )
}

export default App
